import { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox';
import { colors } from '../colors';

export const checkbox: CheckboxDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        borderColor: colors.textWeak,
        hoverBorderColor: '{surface.0}',
        checkedDisabledBorderColor: '{content.borderColor}',
      },
    },
  },
};
